<div class="toolbar-container">
  <h3>{{ title }}</h3>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
